import { render, staticRenderFns } from "./PartidaPresupuestal.vue?vue&type=template&id=3610185b&"
import script from "./PartidaPresupuestal.vue?vue&type=script&lang=js&"
export * from "./PartidaPresupuestal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports